// extracted by mini-css-extract-plugin
export default {"button_div":"ButtonView_button_div__K6sLW","loading":"ButtonView_loading__N2EBE"};